import React from 'react';
import { FaCompass, FaDraftingCompass, FaTools } from 'react-icons/fa';

const Products = () => {
    return (
        <section id="products" className="architectural-bg" style={{ padding: 'var(--section-padding)', background: '#080808', position: 'relative', overflow: 'hidden' }}>
            {/* Background Ghost Text */}
            <div className="wip-ghost-text" style={{ 
                position: 'absolute', 
                top: '50%', 
                left: '50%', 
                transform: 'translate(-50%, -50%)',
                fontSize: 'clamp(5rem, 15vw, 12rem)',
                fontWeight: '900',
                color: 'rgba(255,255,255,0.02)',
                whiteSpace: 'nowrap',
                pointerEvents: 'none',
                zIndex: 0,
                letterSpacing: '10px'
            }}>
                ARCHIVES
            </div>

            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="row mb-5">
                    <div className="col-lg-12 text-center">
                        <span className="section-index">04</span>
                        <h2 className="section-head-main">Curated Products</h2>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="wip-container p-5 text-center" style={{ 
                            background: 'rgba(255,255,255,0.01)',
                            border: '1px solid rgba(197, 160, 89, 0.1)',
                            position: 'relative',
                            backdropFilter: 'blur(10px)'
                        }}>
                            {/* Technical Corner Brackets */}
                            <div className="wip-corner top-left"></div>
                            <div className="wip-corner top-right"></div>
                            <div className="wip-corner bottom-left"></div>
                            <div className="wip-corner bottom-right"></div>

                            <div className="mb-4 d-flex justify-content-center gap-4" style={{ color: 'var(--secondary-color)', fontSize: '2rem', opacity: 0.6 }}>
                                <FaDraftingCompass className="wip-icon-anim" />
                                <FaCompass className="wip-icon-anim" style={{ animationDelay: '0.2s' }} />
                                <FaTools className="wip-icon-anim" style={{ animationDelay: '0.4s' }} />
                            </div>

                            <h3 className="mb-3" style={{ fontWeight: '300', letterSpacing: '5px', textTransform: 'uppercase' }}>
                                Work In <span style={{ color: 'var(--secondary-color)', fontWeight: '600' }}>Progress</span>
                            </h3>

                            <p style={{ color: 'var(--text-secondary)', maxWidth: '500px', margin: '0 auto', fontSize: '0.9rem', lineHeight: '1.8', fontWeight: '300' }}>
                                Our exclusive catalog of architectural elements and bespoke products is currently being finalized. 
                                We are meticulously selecting only the finest pieces to represent the <span style={{ color: '#fff' }}>Al Waseeq</span> standard.
                            </p>

                            <div className="mt-5 d-flex align-items-center justify-content-center gap-3">
                                <div style={{ height: '1px', width: '30px', background: 'rgba(197,160,89,0.3)' }}></div>
                                <span style={{ fontSize: '0.65rem', letterSpacing: '3px', color: 'rgba(255,255,255,0.4)', fontWeight: '500' }}>COMING SOON</span>
                                <div style={{ height: '1px', width: '30px', background: 'rgba(197,160,89,0.3)' }}></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Optional: Subtle blurred placeholders for cards below */}
                <div className="row g-4 mt-4 opacity-25">
                    {[1, 2, 3, 4].map(i => (
                        <div key={i} className="col-md-3">
                            <div className="arch-card p-4" style={{ height: '150px', borderStyle: 'dashed' }}></div>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
                .wip-corner {
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    border: 1px solid var(--secondary-color);
                    opacity: 0.4;
                }
                .top-left { top: 0; left: 0; border-right: none; border-bottom: none; }
                .top-right { top: 0; right: 0; border-left: none; border-bottom: none; }
                .bottom-left { bottom: 0; left: 0; border-right: none; border-top: none; }
                .bottom-right { bottom: 0; right: 0; border-left: none; border-top: none; }

                .wip-icon-anim {
                    animation: wipFloat 3s infinite ease-in-out;
                }

                @keyframes wipFloat {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }

                .wip-container {
                    transition: all 0.5s ease;
                }
                
                .wip-container:hover {
                    border-color: rgba(197, 160, 89, 0.3);
                    background: rgba(255,255,255,0.02) !important;
                }
            `}</style>
        </section>
    );
};

export default Products;
